import { render, staticRenderFns } from "./circleprogress.vue?vue&type=template&id=5220e654&"
import script from "./circleprogress.vue?vue&type=script&lang=js&"
export * from "./circleprogress.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports